import { FreelyPaymentErrorType, StripePaymentErrorType, TripApiErrorType } from './types';

export class BaseError<TType extends string> extends Error {
  public code: string | undefined;
  public details: Record<string, any> | undefined;

  constructor(name: string, type: TType, details?: Record<string, any>) {
    super(type);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = `${name} (${type})`;
    this.details = details;

    if (
      details !== null &&
      details !== undefined &&
      'message' in details &&
      typeof details.message === 'string'
    ) {
      this.message = details.message;
    }

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}

export class StripePaymentError extends BaseError<StripePaymentErrorType> {
  constructor(type: StripePaymentErrorType, details?: Record<string, any>) {
    super('StripePaymentError', type, details);
    Object.setPrototypeOf(this, StripePaymentError.prototype);
  }
}

export class FreelyPaymentError extends BaseError<FreelyPaymentErrorType> {
  constructor(type: FreelyPaymentErrorType, details?: Record<string, any>) {
    super('FreelyPaymentError', type, details);
    Object.setPrototypeOf(this, FreelyPaymentError.prototype);
  }
}

export class TripApiError extends BaseError<TripApiErrorType> {
  constructor(type: TripApiErrorType, details?: Record<string, any>) {
    super('TripApiError', type, details);
    Object.setPrototypeOf(this, TripApiError.prototype);
  }
}
